export const popularDestinationsData = [
    {
        image: '/assets/images/destinations/greece.jpg',
        alt: 'Greece Charters',
        cardTitle: 'Mediterranean',
        imageText: 'Greece',
        link: '/location/greece',
        content: {
            title: 'Greece is a sailing haven steeped in history, offering crystal- clear waters, sun- drenched islands, and charming harbours brimming with character.With hundreds of islands across multiple regions — including the Cyclades, Ionian, and Dodecanese — Greece offers something for every kind of sailor.',
            content: 'Expect reliable summer winds, particularly the Meltemi in the Cyclades, which can reach 20–25 knots — ideal for experienced sailors seeking more challenging conditions.For gentler cruising, the Ionian Islands offer calmer waters and easy line - of - sight navigation.The best time to sail is from May to October, when the weather is warm, the seas are inviting, and every port stop brings a taste of authentic Greek culture, cuisine, and hospitality.',
        },
        heroText: 'Each island in Greece holds a story worth discovering',
        additionalContent: null,
        location: 'greece',
        fullLocation: ['Mediterranean', 'Greece'],
        duration: null,
    },
    {
        image: '/assets/images/destinations/antigua.jpg',
        alt: 'Sri Lanka',
        cardTitle: 'Caribbean',
        imageText: 'Antigua',
        link: '/location/antigua-and-barbuda',
        content: {
            title: "Antigua is a sailor's paradise, offering crystal-clear waters, steady trade winds, and over 365 beaches to explore — one for every day of the year. This Caribbean gem is perfect for both relaxed cruising and island-hopping adventures, making it a top choice for charterers seeking a mix of beauty and variety",
            content: "Antigua enjoys consistent easterly trade winds averaging 15–20 knots, with well-protected anchorages and world-class marinas like English Harbour and Jolly Harbour. The best time to sail is between December and May, outside the hurricane season, when the weather is dry and temperatures are warm. From quiet coves to lively beach bars, Antigua offers the ideal blend of sailing conditions and Caribbean charm."
        },
        heroText: 'Explore the Caribbean coastlines of Antigua & Barbuda in complete freedom',
        additionalContent: null,
        location: 'antigua',
        fullLocation: ['Caribbean', 'Antigua'],
        duration: null,
    },
    {
        image: '/assets/images/destinations/st-lucia.jpg',
        alt: 'Grenada Charters',
        cardTitle: 'Mediterranean',
        imageText: 'St. Lucia',
        link: '/location/st-lucia',
        content: {
            title: 'Saint Lucia is a stunning Caribbean sailing destination, known for its dramatic Piton peaks, lush rainforests, and vibrant Creole culture. It’s ideal for those seeking both natural beauty and a touch of adventure, with excellent sailing conditions and a warm, welcoming island atmosphere.',
            content: 'Sailing conditions in Saint Lucia are typically reliable, with steady trade winds averaging 15–20 knots and well-equipped marinas like Rodney Bay offering a great starting point. Popular routes often include sailing south to the Grenadines or exploring the island’s west coast. The best time to sail is from December to May, during the dry season, when the weather is warm, the seas are calm, and the island comes alive with music, food, and Caribbean charm.',
        },
        heroText: 'Sail St. Lucia’s lush, volcanic shores and hidden anchorages',
        additionalContent: null,
        location: 'st-lucia',
        fullLocation: ['Mediterranean', 'St. Lucia'],
        duration: null,
    },
    {
        image: '/assets/images/destinations/bahamas.jpg',
        alt: 'Bahamas Charters',
        cardTitle: 'Caribbean',
        imageText: 'British Virgin Islands',
        link: '/location/british-virgin-islands',
        content: {
            title: 'The British Virgin Islands are widely regarded as one of the best sailing destinations in the world, thanks to their sheltered waters, short island hops, and consistent trade winds. Ideal for beginners and experienced sailors alike, the BVI offers a picture-perfect blend of calm seas, tropical scenery, and lively island culture.',
            content: 'With steady easterly winds around 15–20 knots and line-of-sight navigation, sailing in the BVI is smooth and accessible. Popular stops include Tortola, Virgin Gorda, Anegada, and Jost Van Dyke — each offering unique charm, from white-sand beaches to iconic beach bars. The peak sailing season runs from December to May, offering dry weather, warm temperatures, and ideal conditions for an unforgettable Caribbean charter.',
        },
        heroText: 'See the iconic beauty of the British Virgin Islands by sea',
        additionalContent: null,
        location: 'british-virgin-islands',
        fullLocation: ['Caribbean', 'British Virgin Islands'],
        duration: null,
    },
    {
        image: '/assets/images/destinations/grenada.jpg',
        alt: 'Grenada Charters',
        cardTitle: 'Caribbean',
        imageText: 'Grenada',
        link: '/location/grenada',
        content: {
            title: 'Grenada offers an idyllic sailing experience with its warm, calm waters, lush landscapes, and laid-back Caribbean charm. Known as the "Spice Island", it’s perfect for cruisers looking to combine scenic anchorages with authentic island culture and quieter sailing routes.',
            content: 'Grenada enjoys consistent trade winds of 15–20 knots and fewer crowds compared to more northerly Caribbean destinations. It’s an excellent choice for intermediate sailors, with smooth passages to nearby islands like Carriacou and the Grenadines. The ideal time to sail is from December to May, during the dry season and outside the hurricane belt — offering reliable weather and serene tropical beauty.',
        },
        heroText: 'Sail Grenada’s turquoise waters into the heart of the Grenadines',
        additionalContent: null,
        location: 'grenada',
        fullLocation: ['Caribbean', 'Grenada'],

        duration: null,
    },
    {
        image: '/assets/images/destinations/croatia.jpg',
        alt: 'Croatia Charters',
        cardTitle: 'Mediterranean',
        imageText: 'Croatia',
        link: '/location/croatia',
        content: {
            title: 'Croatia is a top Mediterranean sailing destination, known for its crystal-clear waters, historic coastal towns, and over a thousand islands waiting to be explored. With a blend of culture, natural beauty, and modern marinas, it’s perfect for both relaxing charters and more adventurous itineraries.',
            content: 'Sailing conditions in Croatia are generally calm and predictable, with steady northwesterly winds (Maestral) around 10–20 knots in summer. Popular routes stretch from Split to Dubrovnik, taking in islands like Hvar, Vis, and Korčula. The best time to sail is from May to October, with July and August offering the warmest weather, vibrant nightlife, and lively waterfronts — ideal for discovering the Adriatic at your own pace.',
        },
        heroText: 'Feel the Adriatic breeze between Croatia’s ports and hidden bays',
        additionalContent: null,
        location: 'croatia',
        fullLocation: ['Mediterranean', 'Croatia'],
        duration: null,
    },
    {
        image: '/assets/images/destinations/bahamas.jpg',
        alt: 'Martinique Charters',
        cardTitle: 'Caribbean',
        imageText: 'British Virgin Islands',
        link: '/location/british-virgin-islands',
    },
    {
        image: '/assets/images/destinations/st-lucia.jpg',
        alt: 'St. Lucia Charters',
        cardTitle: 'Caribbean',
        imageText: 'St. Lucia Charters',
        link: '/location/st-lucia',
    },
    {
        image: '/assets/images/destinations/tailand.jpg',
        alt: 'Thailand Charters',
        cardTitle: 'Southeast Asia',
        imageText: 'Thailand Charters',
        link: '/location/thailand',
    },
    {
        image: '/assets/images/destinations/seychelles.jpg',
        alt: 'Seychelles Charters',
        cardTitle: 'Indian Ocean',
        imageText: 'Seychelles Charters',
        link: '/location/seychelles',
    },
];